import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { bumexFeaturesKeys } from '@panel/core/src/constants/bumexFeatures';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';

/**
 * Custom hook para manejar la lógica del banner
 * @param {boolean} isMainRoute - Si está en la ruta principal
 * @param {boolean} isDraftFromPanel - Si es un borrador del panel
 * @param {boolean} isLocationRoute - Si está en la ruta de ubicación
 * @param {boolean} isEdition - Si esta en la vista resumen de edición
 * @returns {object} - Objeto con las propiedades del banner y función cleanFormIsDirty
 */
const useBannerLogic = (
  isMainRoute = false,
  isDraftFromPanel = false,
  isLocationRoute = false,
  isEdition = false,
  isMobile = false
) => {
  const isFromCRM = Cookies.get('crmSessionId');
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const showWelcomeBanner = bumexFeatures.get(bumexFeaturesKeys.SHOW_BANNER_TO_OLD_PUB) || false;

  const showBannerOldReppro = isMobile
    ? false
    : (showWelcomeBanner && isMainRoute) ||
      (isFromCRM && isMainRoute) ||
      (showWelcomeBanner && isDraftFromPanel && isLocationRoute) ||
      (isFromCRM && isDraftFromPanel && isLocationRoute) ||
      (showWelcomeBanner && isEdition) ||
      (isFromCRM && isEdition);

  return {
    isFromCRM,
    showWelcomeBanner,
    showBannerOldReppro
  };
};

export default useBannerLogic;
